
import {spaceship} from 'helpers/sort'
import BaseTask from 'models/BaseTask'

export default class DailyTask extends BaseTask {

  // アクセサ: 検索用キー値を取得
  static key(storeCode, floorCode, taskCode, date) {
    if(storeCode instanceof Object) {
      floorCode = storeCode.floor_code
      taskCode  = storeCode.task_code
      date      = storeCode.date
      storeCode = storeCode.store_code
    }
    return storeCode + '/' + floorCode + '/' + taskCode + '/' + date
  }

  // 配列処理: 並び順でソート (レジシフト画面用)
  static sortForShifts(tasks) {
    return Object.values(tasks).sort((a, b) =>
      spaceship(a.display_order, b.display_order) ||
      spaceship(a.task_code,     b.task_code)
    )
  }

}
